import { useState, useEffect } from "react"
import { Textarea } from "@/components/ui/textarea"
import { Button } from "@/components/ui/button"
import { MessageCircle, X } from "lucide-react"
import LinkedinProfileInfo from "./linkedin_profile_info"

const LinkedinFirstComment = ({
  initialReplyContent = "",
  replyId,
  onSave,
  onDelete,
  displayName,
  handleLabel,
  avatarUrl,
  disabled,
  compactTrigger = false,
  open,
  onOpenChange,
  triggerOnly = false,
  editorOnly = false,
}) => {
  const [showReply, setShowReply] = useState(!!initialReplyContent || !!replyId)
  const [replyContent, setReplyContent] = useState(initialReplyContent)
  const isControlled = typeof open === "boolean"
  const replyVisible = isControlled ? open : showReply

  useEffect(() => {
    setReplyContent(initialReplyContent)
  }, [initialReplyContent])

  const handleChange = (value) => {
    setReplyContent(value)
    onSave?.(value)
  }

  const handleAddReply = () => {
    if (!isControlled) setShowReply(true)
    onOpenChange?.(true)
    setReplyContent(initialReplyContent)
  }

  const handleRemoveReply = () => {
    if (!isControlled) setShowReply(false)
    onOpenChange?.(false)
    if (replyId) onDelete?.(replyId)
    handleChange("")
  }

  if (triggerOnly) {
    if (disabled || replyVisible) return null
    return (
      <button
        type="button"
        onClick={handleAddReply}
        className="flex h-7 w-7 items-center justify-center text-muted-foreground transition-colors hover:text-foreground"
        aria-label="Add first comment"
        title="Add first comment"
      >
        <MessageCircle className="h-4 w-4" />
      </button>
    )
  }

  if (!replyVisible) {
    if (editorOnly) return null
    if (disabled) return null 
    if (compactTrigger) {
      return (
        <button
          type="button"
          onClick={handleAddReply}
          className="flex h-7 w-7 items-center justify-center text-muted-foreground transition-colors hover:text-foreground"
          aria-label="Add first comment"
          title="Add first comment"
        >
          <MessageCircle className="h-4 w-4" />
        </button>
      )
    }

    return (
      <div className="flex justify-center">
        <Button
          type="button"
          variant="ghost"
          size="sm"
          onClick={handleAddReply}
          className="text-muted-foreground hover:text-foreground"
        >
          <MessageCircle className="h-4 w-4" />
          Add Comment
        </Button>
      </div>
    )
  }

  return (
    <div className="space-y-3 rounded-lg border p-4">
      <div className="flex items-center justify-between">
        <LinkedinProfileInfo
          displayName={displayName}
          handleLabel={handleLabel}
          avatarUrl={avatarUrl}
        />
        {!disabled && (
        <Button
          type="button"
          variant="ghost"
          size="sm"
          onClick={handleRemoveReply}
          className="h-7 w-7 p-0 text-muted-foreground hover:text-destructive"
        >
          <X className="h-4 w-4" />
        </Button>
        )}
      </div>
      <Textarea
        value={replyContent}
        onChange={(e) => handleChange(e.target.value)}
        placeholder="Enter your comment here..."
        disabled={disabled}
        className="min-h-[80px] !border-0 !bg-transparent !ring-0 !ring-offset-0 focus-visible:!ring-0 resize-none"
      />
    </div>
  )
}

export default LinkedinFirstComment
